/* eslint-disable no-unused-vars */
import $ from 'jquery';
import { Reveal } from 'foundation-sites';

document.querySelectorAll('.js-modal').forEach((modal) => {
    const m = new Reveal($(modal));
});
